import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { orderBy } from 'lodash';
import { ComponentDimensions } from '../../utils/component-dimensions';
import { LayoutService } from '../../../Services/layout/layout.service';
import { ObservablesService } from '../../../Services/observables/observables';
import { StoreService } from '../../../Services/store';

@Component({
	selector: 'floater',
	template: `
		<div class="products">
			<div class="product" [ngClass]="{ disabled: product.disabled }" *ngFor="let product of floater.products">
				{{ product.name }}
			</div>
		</div>

		<nav>
			<div class="carriers">
				<div class="carrier" *ngFor="let carrier of floater.carriers">
					<svg width="90" height="35" viewBox="0 0 90 35">
						<defs>
							<filter id="filter">
								<feColorMatrix id="gray" type="matrix" values="0 0 0 0 0, 0 0 0 0 0, 0 0 0 0 0, 0 0 0 0.4 0" />
							</filter>
						</defs>
						<image
							*ngIf="carrier.disabled; else noFilter"
							x="0"
							y="0"
							width="90"
							height="35"
							filter="url(#filter)"
							[attr.xlink:href]="getImageUrl(carrier)"
						/>
						<ng-template #noFilter>
							<image x="0" y="0" width="90" height="35" [attr.xlink:href]="getImageUrl(carrier)" />
						</ng-template>
					</svg>
				</div>
			</div>
			<round-chevron isOpen="isOpen" (click)="toggle()"></round-chevron>
		</nav>

		<div style="clear: both;"></div>
		<div class="well-container" *ngIf="isOpen">
			<control [control]="control" context="page" *ngFor="let control of floater.controls"> </control>
		</div>
	`,
	styleUrls: ['./floater.component.scss'],
})
export class floaterComponent implements OnInit {
	@Input() floater: any;
	isOpen: boolean;
	pageTitle: string;
	resizeCallback: any;
	constructor(
		private layoutService: LayoutService,
		private elementRef: ElementRef,
		private renderer: Renderer2,
		private componentDimensions: ComponentDimensions,
		private observablesService: ObservablesService,
		private storeService: StoreService
	) {
		this.isOpen = false;
		this.floater = orderBy(this.floater, 'sequence', 'desc');
		this.pageTitle = this.layoutService.staticLayout.getValue().data.ui.page.title;
		this.observablesService.pageUpdated.subscribe((action) => {
			if (this.pageTitle != this.layoutService.staticLayout.getValue().data.ui.page.title) {
				this.isOpen = false;
			}
		});
	}

	getImageUrl(carrier) {
		const url: string = carrier.imageUrl;
		if (url.indexOf('Resource') > -1) {
			return url;
		} else {
			const n = url.lastIndexOf('.');
			return carrier.disabled ? url.substring(0, n) + '.disabled' + url.substring(n) : url;
		}
	}

	toggle() {
		this.isOpen = !this.isOpen;
	}

	async ngOnInit() {
		this.setMaxHeight(document.getElementsByTagName('header')[0].getBoundingClientRect().height);
	}

	setMaxHeight(value) {
		const elem = this.elementRef.nativeElement;
		this.renderer.setStyle(elem, 'max-height', `calc(100vh - ${value}px)`);
	}
}
